/**
 * This custom hook should allow components access to the current
 * form values.
 */
import { useState } from "react";
import {
  CustomerDataStateObject,
  DEFAULT_CUSTOMER_DATA_STATE
} from "./useCustomerDataState";

export interface CustomerFormStateObject extends CustomerDataStateObject {
  /** The customer has consented to data sharing and personalisation. */
  confirmConsent: boolean | null | undefined;
  /** The customer has confirmed having the minimum age. */
  confirmAge: boolean | null | undefined;
  /** The customer's signature data. */
  signatureData: string | null | undefined;
}

export type SetCustomerFormState = React.Dispatch<
  React.SetStateAction<CustomerFormStateObject>
>;

export type CustomerFormState = [CustomerFormStateObject, SetCustomerFormState];

export const DEFAULT_CUSTOMER_FORM_STATE: CustomerFormStateObject = {
  ...DEFAULT_CUSTOMER_DATA_STATE,
  confirmConsent: false,
  confirmAge: false,
  signatureData: null
};

export default function useCustomerDataState(
  initialState?: Partial<CustomerFormStateObject>
): CustomerFormState {
  return useState<CustomerFormStateObject>({
    ...DEFAULT_CUSTOMER_FORM_STATE,
    ...initialState
  });
}
